import './styles.scss';
import { registerFragment } from '@neptune/cx/registry';
import {DisposalSet, select, selectAll} from '@neptune/cx/utils';

const gc = new DisposalSet();
registerFragment('chroa-contact-button', (fragmentEl, config, meta) => {
    const contactButton = selectAll<HTMLButtonElement>(fragmentEl, '.chroa-contact-button-container button')[0];
    if (!contactButton) return; // its not there because we're not logged in
    const contactMenu = select<HTMLDivElement>(fragmentEl, '.chroa-contact-button__content');
    (gc.register(contactButton)
        .addListener('click', () => {
            console.log(contactButton.getAttribute('aria-expanded'));
            if(contactButton.getAttribute('aria-expanded') == 'false') {
                contactButton.setAttribute('aria-expanded', 'true');
            } else {
                contactButton.setAttribute('aria-expanded', 'false');
            }
        })
    );
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
